<template>
    <div id="main">
        <sek-header
            @changeDrawer="updateDrawer" />
        <sek-drawer
            @changeDrawer="updateDrawer"
            :drawer="drawer" />
        <div id="wrapper">
            <v-expand-transition mode="out-in">
                <router-view />
            </v-expand-transition>
        </div>
        <sek-footer />
    </div>
</template>

<script>
import Header from '../../components/base/Header.vue'
import Footer from '../../components/base/Footer.vue'
import Drawer from '../../components/base/Drawer.vue'

export default {
    components: {
        'sek-header': Header,
        'sek-footer': Footer,
        'sek-drawer': Drawer
    },
    data() {
        return {
            drawer: false
        }
    },
    methods: {
        updateDrawer(val) {
            this.drawer = val
        }
    },
}
</script>

<style lang="scss">
#main {
    height: 100%;
    display: flex;
    flex-direction: column;

    #wrapper {
        width: 100%;
        height: 100%;
    }

    // @media screen and (max-width: 480px) {
    //     #wrapper {
    //         padding: 108px 28px 28px 28px;
    //     }
    // }
}
</style>